export const LoadingState = () => (
  <div className="FieldSet--LoadingState">
    {/* <LoadingSpinner /> */}
    ...loading
  </div>
);
